import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../../Command";
import { FetchAssociatedUpdatePackagesReqData } from "./FetchAssociatedUpdatePackagesReqData";
import { FetchAssociatedUpdatePackagesResData } from "./FetchAssociatedUpdatePackagesResData";

const ENDPOINT = "/device_update/associated_package";

export class FetchAssociatedUpdatePackagesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    payload: FetchAssociatedUpdatePackagesReqData;

    constructor(payload: FetchAssociatedUpdatePackagesReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchAssociatedUpdatePackagesResData> {
        let res = await this.executeCommand({ ...this.payload });
        return new FetchAssociatedUpdatePackagesResData(res);
    }
}
